/**
 * 計算過程と詳細レポートを表示するモーダル（漸進的開示・案B）。
 * 右ペインのアコーディオンでは足りない場合に「大きく開いて確認」する用。
 */

import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CalculationDetailsContent from './CalculationDetailsContent';

interface CalculationDetailsModalProps {
  show: boolean;
  onHide: () => void;
  analysisType: string;
  rawResult: unknown;
  analysisOptions?: import('../../../../stores/systems/keisuke/dashboardStore').AnalysisOptions;
  gridData?: import('../../../../stores/systems/keisuke/dashboardStore').DataRow[];
  anovaPairwise?: import('../../../../stores/systems/keisuke/dashboardStore').GroupComparisonRow[];
  ttestComparisonCount?: number;
}

export default function CalculationDetailsModal({
  show,
  onHide,
  analysisType,
  rawResult,
  analysisOptions,
  gridData,
  anovaPairwise,
  ttestComparisonCount,
}: CalculationDetailsModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      scrollable
      className="calculation-details-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-list-alt me-2 text-primary fs-5" aria-hidden />
          {t('keisuke.dashboard.calculationDetailsTitle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CalculationDetailsContent
          analysisType={analysisType}
          rawResult={rawResult}
          compact={false}
          analysisOptions={analysisOptions}
          gridData={gridData}
          anovaPairwise={anovaPairwise}
          ttestComparisonCount={ttestComparisonCount}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          title={t('keisuke.dashboard.tooltips.closeModal')}
          aria-label={t('keisuke.dashboard.tooltips.closeModal')}
        >
          <i className="fas fa-times me-1 fs-5" aria-hidden />
          {t('keisuke.dashboard.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
